module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_8011.5a6adb6d.png";